/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CustomerResponse from './CustomerResponse';
import Options from './Options';
import SensorResponse from './SensorResponse';
import SensorV1RecordResponse from './SensorV1RecordResponse';
import TankHistory from './TankHistory';

/**
* The GetSensorResponse model module.
* @module model/GetSensorResponse
* @version 2020-12-7
*/
export default class GetSensorResponse {
    /**
    * Constructs a new <code>GetSensorResponse</code>.
    * @alias module:model/GetSensorResponse
    * @class
    * @param sensor {module:model/SensorResponse} 
    * @param result {module:model/GetSensorResponse.ResultEnum} 
    */

    constructor(sensor, result) {
        
        
        this['sensor'] = sensor;
        this['result'] = result;
        
    }

    /**
    * Constructs a <code>GetSensorResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/GetSensorResponse} obj Optional instance to populate.
    * @return {module:model/GetSensorResponse} The populated <code>GetSensorResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GetSensorResponse();
                        
            
            if (data.hasOwnProperty('sensor')) {
                obj['sensor'] = SensorResponse.constructFromObject(data['sensor']);
            }
            if (data.hasOwnProperty('customer')) {
                obj['customer'] = CustomerResponse.constructFromObject(data['customer']);
            }
            if (data.hasOwnProperty('records')) {
                obj['records'] = ApiClient.convertToType(data['records'], [SensorV1RecordResponse]);
            }
            if (data.hasOwnProperty('tankHistories')) {
                obj['tankHistories'] = ApiClient.convertToType(data['tankHistories'], [TankHistory]);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
            if (data.hasOwnProperty('options')) {
                obj['options'] = Options.constructFromObject(data['options']);
            }
        }
        return obj;
    }

    /**
    * @member {module:model/SensorResponse} sensor
    */
    'sensor' = undefined;
    /**
    * @member {module:model/CustomerResponse} customer
    */
    'customer' = undefined;
    /**
    * レコード
    * @member {Array.<module:model/SensorV1RecordResponse>} records
    */
    'records' = undefined;
    /**
    * タンクの履歴
    * @member {Array.<module:model/TankHistory>} tankHistories
    */
    'tankHistories' = undefined;
    /**
    * @member {module:model/GetSensorResponse.ResultEnum} result
    */
    'result' = undefined;
    /**
    * @member {module:model/Options} options
    */
    'options' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "NG"
         * @const
         */
        "NG": "NG",
        /**
         * value: "OK"
         * @const
         */
        "OK": "OK"    };

}
